import { useRequestsHandler } from '../redux/reducer/requestsHandler';
import { useEffect, useMemo } from 'react';

export const useRequestsHandlerData = (requestConfigs = []) => {
  const requestsHandler = useRequestsHandler();

  const isPending = useMemo(() => {
    const addresses = requestConfigs.map(({ address }) => address);
    return Object.entries(requestsHandler).reduce(
      (acc, [key, { status }]) => addresses.includes(key) && (status === 'pending' || acc),
      false,
    );
  }, [requestsHandler, requestConfigs]);

  const requestHandleLogic = useMemo(
    () => ({
      pending: async (data, config) => {
        await config.pending?.(data);
      },
      fulfilled: async (data, config) => {
        try {
          await config.fulfilled?.(data);
        } catch (error) {
          console.error('GA TMG [RequestsHandler] ❌ Ошибка в config.fulfilled:', error);
        }

        config.settled?.();
      },
      rejected: async (data, config) => {
        await config.rejected?.(data);
        config.settled?.();
      },
    }),
    [],
  );

  useEffect(() => {
    requestConfigs.forEach((config) => {
      const request = requestsHandler[config.address];

      if (request) {
        const handler = requestHandleLogic[request.status];
        if (handler) {
          handler({ ...(request.data || {}), meta: request.meta }, config);
        }
      }
    });
  }, [requestsHandler, requestConfigs, requestHandleLogic]);

  return isPending;
};
